import React, { useContext, useEffect } from "react";
import AlertaContext from "../../context/alertas/alertaContext";
import AuthContext from "../../context/autenticacion/authContext";
import ProspectoContext from "../../context/doctores/prospectos/prospectoContext";
import TopBar from "../layout/TopBar";
import { Link } from "react-router-dom";

const Pacientes = (props) => {
  const authContext = useContext(AuthContext);
  const { usuario, usuarioAPIAutenticado } = authContext;

  const prospectoContext = useContext(ProspectoContext);
  const { prospectos, obtenerProspectos } = prospectoContext;

  useEffect(() => {
    usuarioAPIAutenticado(1);

    buscarCliente("");

    //eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    if (e.target.name === "buscar") {
      buscarCliente(e.target.value);
    }
  };

  const buscarCliente = (texto) => {
    if (texto.length === 0 || texto.length > 2) {
      let filtro = texto.length > 0 ? texto : "all";
      obtenerProspectos(
        JSON.parse(localStorage.getItem("usuario")).entidadId,
        filtro
      );
    }
  };

  const toResultados = (id) => {
    props.history.push("/resultados", { pacienteId: id });
  };

  return (
    <div>
      <TopBar />
      <div className="container">
        <section>
          <div className="my30 card p10">
            <div className="row">
              <div className="col-md-6 text-left">
                <h3 className="my0">Mis pacientes</h3>
              </div>
              <div className="col-md-6 text-right">
                <Link className="btn btn-primary" to="/prospectos">
                  Nuevo
                </Link>
              </div>
              {/*<div className="col-md-6 text-right">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => cerrarSesion()}>Nuevo</button>
                            </div>*/}
            </div>
            <div className="row p10">
              <div className="col-md-5 px5">
                <label htmlFor="">Buscar cliente</label>
                <div className="inupt-group">
                  <input
                    type="text"
                    id="buscar"
                    name="buscar"
                    onChange={handleChange}
                    className="form-control"
                    placeholder="Buscar por nombre o RFC"
                  />
                </div>
              </div>
            </div>
            <div className="row p15">
              <div className="table">
                {!prospectos ? (
                  <p className="text-center">No existen resultados</p>
                ) : (
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>RFC</th>
                        <th className="text-center">Edad</th>
                        <th className="text-center">Historial clínico</th>
                        <th className="text-center">Programar cita</th>
                      </tr>
                    </thead>
                    <tbody>
                      {prospectos.map((prospecto, index) => (
                        <tr
                          key={index}
                          className={index % 2 === 0 ? "active" : ""}
                        >
                          <td>{prospecto.nombreCompleto}</td>
                          <td>{prospecto.rfc}</td>
                          <td className="text-center">{prospecto.edad}</td>
                          <td className="text-center">
                            {prospecto.esPacienteDoctorActual === 1 && (
                              <Link
                                to={{
                                  pathname: "/resultados",
                                  state: { pacienteId: prospecto.entidadId },
                                }}
                              >
                                <span className="material-icons-outlined">
                                  assignment
                                </span>
                              </Link>
                            )}
                          </td>
                          <td className="text-center">
                            <Link
                              to={{
                                pathname: "/citas",
                                state: {
                                  pacienteId: prospecto.entidadId,
                                  pacienteNombre: prospecto.nombreCompleto,
                                  doctorId: JSON.parse(
                                    localStorage.getItem("usuario")
                                  ).entidadId,
                                },
                              }}
                            >
                              <span className="material-icons-outlined">
                                event
                              </span>
                            </Link>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Pacientes;
